




































































































































































import { Component, Prop, Ref, Watch, PropSync } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import Decisions from '@/store/modules/Decisions';
import Choices, { Choice } from '@/store/modules/Choices';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { REQUIRED } from '@/rules';
import _, { property } from 'lodash';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import { ResourceList, ChoiceList, ChoiceListItem, ListType } from '@/api/model/ResourceList';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);
const workspaceModule = getModule(WorkspaceOptions);

@Component({
    components: { DescriptionEditor, ConfirmationDialog },
})
export default class ChoiceListInput extends Vue {
    @Prop({ default: true, type: Boolean })
    show!: boolean;
    
    // passing list for editing from parent
    @Prop({ default: () => ({}), type: Object })
    listFromParent!: any;

    // passing choices from parent
    @Prop({ default: () => ([]), type: Array })
    choicesFromParent!: Choice[];

    @Prop({ default: false })
    isEdit!: any;

    @PropSync('save', { default: false, type: Boolean })
    saveSync!: boolean;

    @PropSync('clear', { default: false, type: Boolean })
    clearSync!: boolean;

    @PropSync('loading', { default: false, type: Boolean })
    loadingSync!: boolean;

    @PropSync('saveAsNew', { default: false, type: Boolean })
    saveAsNewSync!: boolean;

    

    @Watch('saveSync')
    private onSave() {
        if (this.saveSync === true) {
            this.submit();
        }
    }

    @Watch('saveAsNewSync')
    private onSaveAsNew() {
        if (this.saveAsNewSync === true) {
            this.submitAsNew();
        }
    }

    @Watch('clearSync')
    private onClose() {
        if (this.clearSync === true) {
            this.clearForm();
        }
    }

    private REQUIRED = REQUIRED;
    private selectedChoiceIndex: number = this.selectedChoiceIdIndex;
    private showLists = true;
    private choiceIds: string[] = [];
    private generating = false;
    private name: string = '';
    private description: string = '';
    private previousLists = [];
    private type: any = { CHOICE: 'CHOICE' };
    private panel = [];
    private listId: string = '';
    private alert = false;
    private alertText = '';
    private alertType = 'success';

    private headers: any[] = [
        { text: 'List Name', value: 'name', sortable: true, width: 160 },
        {
            text: `Number of ${this.pluralChoiceLabel}`,
            value: 'numChoices',
            sortable: true,
            width: 160,
        },
        { text: 'Action', value: 'actions', width: 160 },
    ];

    $refs!: {
        form: HTMLFormElement;
        listName: HTMLInputElement;
    };

    mounted() {
        if (this.isEdit && this.listFromParent) {
            console.log(this.listFromParent);
            this.edit(this.listFromParent);
        }
        if(this.choicesFromParent.length > 0) {
            this.choiceIds = this.choicesFromParent.map(choice => {return choice.id})
        }
        this.showLists = this.show;
    }

    get viewpointsList() {
        return _.sortBy(viewpointsModule.decisionViewpoints || [], 'name');
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get selectedChoiceIdIndex() {
        return this.choicesList.findIndex((c) => c.id === this.selectedChoiceId);
    }

    get selectedChoiceId() {
        return choicesModule.selectedChoiceId;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get unfilteredChoicesList() {
        return choicesModule.unfilteredChoicesList;
    }

    get choiceId(): string {
        if (this.selectedChoiceIndex >= 0 && this.choicesList[this.selectedChoiceIndex]) {
            return this.choicesList[this.selectedChoiceIndex].id;
        }
        return '';
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    // get previouslyCreatedLists() {
    //     if (this.selectedDecision)
    //         return VIEWPOINT_API.getDecisionLists(this.selectedDecision.decisionId);
    // }

    get choices() {
        return choicesModule.unfilteredChoices;
    }

    get taskTitle() {
        if (this.listId) {
            return 'Update';
        } else return 'Create';
    }

    get lists() {
        const lists = _.values(decisionsModule.decisionLists).filter(
            (list: ResourceList) => list.type === 'CHOICE'
        );
        return lists;
    }

    get dataTableList() {
        return this.lists
            .map((res: any) => ({
                decisionId: res.decisionId,
                description: res.description,
                choices: res.choices,
                listId: res.listId,
                type: res.type,
                name: res.name,
                numChoices: res.choices.length,
            }));
    }

    @Watch('listFromParent', { deep: true })
    editFromParent() {
        if (this.isEdit && this.listFromParent) {
            this.edit(this.listFromParent);
        }
    }

    @Watch('show')
    onChangeShow() {
        if(this.choicesFromParent.length > 0) {
            this.choiceIds = this.choicesFromParent.map(choice => {return choice.id})
        }
    }

    private getDelTitle(item: any) {
        return 'Delete list - ' + item.name;
    }

    async submit() {
        try {
            if (!this.name || !this.selectedDecision) {
                this.loadingSync = false;
                this.errorMsg('Missing List Name');
                this.saveSync = false;
                return;
            }
            let choiceItemList: ChoiceListItem[] = [];
            for (let id of this.choiceIds) {
                // console.log(this.choices);
                // console.log(id);
                // console.log(this.choices[id]);

                if (this.choices[id]) {
                    // console.log('pushed');
                    choiceItemList.push({ choiceId: id });
                }
            }

            if (this.listId) {
                let list: ChoiceList = {
                    choices: choiceItemList,
                    decisionId: this.selectedDecision.decisionId,
                    name: this.name,
                    description: this.description,
                    type: this.type.CHOICE,
                    listId: this.listId,
                    ownerUserId: this.selectedDecision.ownerUserId,
                };
                await VIEWPOINT_API.putList(this.selectedDecision.decisionId, this.listId, list);
            } else {
                let list: ChoiceList[] = [
                    {
                        choices: choiceItemList,
                        decisionId: this.selectedDecision.decisionId,
                        name: this.name,
                        description: this.description,
                        type: this.type.CHOICE,
                        ownerUserId: this.selectedDecision.ownerUserId,
                    },
                ];
                await VIEWPOINT_API.createLists(this.selectedDecision.decisionId, list);
            }
            await decisionsModule.getDecisionLists();
            if (!this.listFromParent) {
                this.$refs.form.reset();
                this.clearForm();
            }
            this.successMsg('List ' + this.taskTitle + 'd');
        } catch (err) {
            this.errorMsg('Failed to Save');
        } finally {
            this.loadingSync = false;
            this.saveSync = false;
        }
    }

    async submitAsNew() {
        try {
            if (this.name == null || !this.selectedDecision) {
                this.loadingSync = false;
                this.errorMsg('Missing List Name');
                this.saveAsNewSync = false;
                return;
            }
            let choiceItemList: ChoiceListItem[] = [];
            for (let id of this.choiceIds) {
                // console.log(this.choices);
                // console.log(id);
                // console.log(this.choices[id]);

                if (this.choices[id]) {
                    // console.log('pushed');
                    choiceItemList.push({ choiceId: id });
                }
            }

            let list: ChoiceList[] = [
                {
                    choices: choiceItemList,
                    decisionId: this.selectedDecision.decisionId,
                    name: this.name,
                    description: this.description,
                    type: this.type.CHOICE,
                    ownerUserId: this.selectedDecision.ownerUserId,
                },
            ];
            await VIEWPOINT_API.createLists(this.selectedDecision.decisionId, list);
            
            await decisionsModule.getDecisionLists();
            if (!this.listFromParent) {
                this.$refs.form.reset();
                this.clearForm();
            }
            this.successMsg('List Created');
        } catch (err) {
            this.errorMsg('Failed to Save');
        } finally {
            this.loadingSync = false;
            this.saveAsNewSync = false;
            this.listId = "";
        }
    }

    private cancel() {
        this.clearForm();
        this.$emit('cancel');
    }

    clearForm() {
        if (this.listFromParent && Object.keys(this.listFromParent).length > 0) {
            // reset to default value
            this.edit(this.listFromParent);

        } else {
            //clear the form completly
            this.description = '';
            this.$refs.form.reset();
        }
        this.clearSync = false;
    }

    private edit(list: ChoiceList) {
        // console.log(list);
        this.choiceIds = list.choices.map((id) => id.choiceId);
        this.name = list.name;
        this.description = list.description;
        this.listId = list.listId ? list.listId : '';
        this.$emit('edit');
    }

    private async delList(list: ChoiceList) {
        this.loadingSync = true;

        try {
            if (this.selectedDecision && list.listId) {
                await VIEWPOINT_API.deleteList(this.selectedDecision.decisionId, list.listId).then(
                    (res) => {
                        decisionsModule.getDecisionLists();
                    }
                );
                // this.displayCreatedLists();
                workspaceModule.removeActiveChoiceList(list.listId);
            }
        } catch (err) {
            console.log(err);
            this.alert = true;
            this.alertType = 'error';
            this.alertText = 'Delete Failed';
            this.createAlert();
        }
        this.loadingSync = false;
    }

    private createAlert() {
        setTimeout(() => {
            this.alert = false;
        }, 2000);
    }
    private successMsg(message: any) {
        this.alert = true;
        this.alertType = 'success';
        this.alertText = message;
        this.createAlert();
    }
    private errorMsg(message: any) {
        this.alert = true;
        this.alertType = 'error';
        this.alertText = message;
        this.createAlert();
    }
    private reFocus() {
        setTimeout(() => {
            this.$refs.listName.focus();
        }, 500);
    }
}
